/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@ngx-translate/core/src/translate.pipe';
import * as import4 from '@ngx-translate/core/src/translate.service';
import * as import5 from '@angular/common';
import * as import6 from '@angular/forms';
import * as import7 from '../../../app/shared/directives/no-blank.directive';
import * as import8 from '../../../app/pipes/duration.pipe';
import * as import9 from '../../../$$_gendir/node_modules/ngx-modal/Modal.ngfactory';
import * as import10 from 'ngx-modal/Modal';
import * as import11 from '../../../app/contract/contract-details.component';
import * as import12 from '../../../app/services/contracts.service';
import * as import13 from 'ng2-breadcrumb/app/components/breadcrumbService';
import * as import14 from '../../../app/services/local-storage.service';
import * as import15 from 'angular2-notifications/src/notifications.service';
import * as import16 from '@angular/router';
import * as import17 from '../../../app/services/language.service';
import * as import18 from '../../../app/services/menu.service';
import * as import19 from '../../../app/services/form.service';
import * as import20 from '../../../app/services/rodo-client.service';
import * as import21 from '../../../app/services/date.service';
const styles_ContractDetailsComponent:any[] = ([] as any[]);
export const RenderType_ContractDetailsComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ContractDetailsComponent,
  data: {}
}
);
function View_ContractDetailsComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie danych kontraktu'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ContractDetailsComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                        ',
      '\n                                    '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_ContractDetailsComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[
      [
        'class',
        'info-hint error'
      ]
      ,
      [
        'style',
        'margin-top:-6px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_5)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.changeContractNameForm.controls['contractName'].errors.required;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_ContractDetailsComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),32,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),29,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,4).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,4).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('submit' === en)) {
        const pd_2:any = ((<any>co.changeContractName()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Nazwa kontaktu'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'medium-wide'
      ]
      ,
      [
        'formControlName',
        'contractName'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,16)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,16).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,16)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,16)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,21).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_4)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Zapisz'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Anuluj'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>(co.showChangeContractName = false)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = co.changeContractNameForm;
    ck(v,4,0,currVal_7);
    const currVal_15:any = 'contractName';
    ck(v,18,0,currVal_15);
    const currVal_16:any = co.changeContractNameForm.controls['contractName'].errors;
    ck(v,24,0,currVal_16);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵnov(v,6).ngClassUntouched;
    const currVal_1:any = import0.ɵnov(v,6).ngClassTouched;
    const currVal_2:any = import0.ɵnov(v,6).ngClassPristine;
    const currVal_3:any = import0.ɵnov(v,6).ngClassDirty;
    const currVal_4:any = import0.ɵnov(v,6).ngClassValid;
    const currVal_5:any = import0.ɵnov(v,6).ngClassInvalid;
    const currVal_6:any = import0.ɵnov(v,6).ngClassPending;
    ck(v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import0.ɵnov(v,20).ngClassUntouched;
    const currVal_9:any = import0.ɵnov(v,20).ngClassTouched;
    const currVal_10:any = import0.ɵnov(v,20).ngClassPristine;
    const currVal_11:any = import0.ɵnov(v,20).ngClassDirty;
    const currVal_12:any = import0.ɵnov(v,20).ngClassValid;
    const currVal_13:any = import0.ɵnov(v,20).ngClassInvalid;
    const currVal_14:any = import0.ɵnov(v,20).ngClassPending;
    ck(v,15,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_17:boolean = !co.changeContractNameForm.valid;
    ck(v,28,0,currVal_17);
  });
}
function View_ContractDetailsComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.contract.name;
    ck(v,1,0,currVal_0);
  });
}
function View_ContractDetailsComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showChangeContractNameForm()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('CONTRACTS.CHANGENAME'));
    ck(v,1,0,currVal_0);
  });
}
function View_ContractDetailsComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'blocks header padded'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Okres trwania:'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵppd(3),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'WYGASA: ',
      ''
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,11,0,ck(v,12,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.contract.duration_val,co.contract.duration_unit,co.languageService.getLanguage()));
    ck(v,11,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,15,0,ck(v,16,0,import0.ɵnov((<any>(<any>v.parent).parent),1),co.dateService.formatDate(co.contract.agreement_end),'dd.MM.yyyy'));
    ck(v,15,0,currVal_1);
  });
}
function View_ContractDetailsComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['├──']))
  ]
  ,(null as any),(null as any));
}
function View_ContractDetailsComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['└──']))
  ]
  ,(null as any),(null as any));
}
function View_ContractDetailsComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_11)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_12)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.services[((<any>v.parent).context.index + 1)] && (co.services[((<any>v.parent).context.index + 1)].parent_id == (<any>v.parent).context.$implicit.parent_id));
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = (!co.services[((<any>v.parent).context.index + 1)] || !co.services[((<any>v.parent).context.index + 1)].parent_id);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_ContractDetailsComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),30,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_10)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '%\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    \n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.parent_id;
    ck(v,5,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.name;
    ck(v,6,0,currVal_1);
    const currVal_2:any = v.context.$implicit.service.name;
    ck(v,10,0,currVal_2);
    const currVal_3:any = v.context.$implicit.count;
    ck(v,13,0,currVal_3);
    const currVal_4:any = v.context.$implicit.netto;
    ck(v,16,0,currVal_4);
    const currVal_5:any = (v.context.$implicit.vat * 100);
    ck(v,19,0,currVal_5);
    const currVal_6:any = (v.context.$implicit.netto * v.context.$implicit.count).toFixed(2);
    ck(v,22,0,currVal_6);
    const currVal_7:any = ((v.context.$implicit.netto * v.context.$implicit.count) * (v.context.$implicit.vat + 1)).toFixed(2);
    ck(v,25,0,currVal_7);
  });
}
function View_ContractDetailsComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'heading-h6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Regulaminy']))
  ]
  ,(null as any),(null as any));
}
function View_ContractDetailsComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'row-standard icon icon-download'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' z dnia ',
      ''
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(5,'',co.API_URL,'/company/',co.localStorageService.get('company'),'/contract/',co.contractID,'/regulation_attachment_file/',(<any>v.parent).context.$implicit.id,'/',v.context.$implicit.id,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    const currVal_2:any = import0.ɵunv(v,3,1,ck(v,4,0,import0.ɵnov((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent),1),co.dateService.formatDate(v.context.$implicit.created_at),'dd.MM.yyyy'));
    ck(v,3,0,currVal_1,currVal_2);
  });
}
function View_ContractDetailsComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'row-standard icon icon-download'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' z dnia ',
      ''
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_17)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = v.context.$implicit.attachments;
    ck(v,10,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(4,'',co.API_URL,'/company/',co.localStorageService.get('company'),'/contract/',co.contractID,'/regulation_file/',v.context.$implicit.id,'');
    ck(v,4,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    const currVal_2:any = import0.ɵunv(v,5,1,ck(v,6,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),1),co.dateService.formatDate(v.context.$implicit.created_at),'dd.MM.yyyy'));
    ck(v,5,0,currVal_1,currVal_2);
  });
}
function View_ContractDetailsComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_15)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_16)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.contract.files.length;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.contract.regulations;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_ContractDetailsComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'heading-h6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Inne dokumenty']))
  ]
  ,(null as any),(null as any));
}
function View_ContractDetailsComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'row-standard icon icon-download'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(4,'',co.API_URL,'/company/',co.localStorageService.get('company'),'/contract/',co.contractID,'/file/',v.context.$implicit.id,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    ck(v,3,0,currVal_1);
  });
}
function View_ContractDetailsComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_19)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_20)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.contract.regulations.length;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.contract.files;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_ContractDetailsComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'row-tall-distanced'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'class',
        'heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dokumenty:'])),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_14)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_18)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.contract.regulations.length;
    ck(v,6,0,currVal_0);
    const currVal_1:any = co.contract.files.length;
    ck(v,9,0,currVal_1);
  },(null as any));
}
function View_ContractDetailsComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-short-plus'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Dodaj przekazanie przetwarzania danych osobowych'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.openTermsModal(import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),9))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ContractDetailsComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'heading-h6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Powierzenie przetwarzania danych osobowych'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_22)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !co.contract.rodo_agreement;
    ck(v,6,0,currVal_0);
  },(null as any));
}
function View_ContractDetailsComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),138,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),29,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'blocks blocks-centered'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'strong',[[
        'class',
        'heading-h3'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ':'
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_6)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_7)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-medium-wide'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.newMessage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zadaj pytanie'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'blocks header padded'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Status kontraktu:'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'b',([] as any[]),[[
        4,
        'color',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_8)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'blocks header padded'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Okres rozliczeniowy:'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'row-distanced'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'blocks header padded'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Usługi:'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),39,'div',[[
        'class',
        'table-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),36,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),27,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),24,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Nazwa'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Typ usługi'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Ilość'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Cena netto'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Vat'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wartość netto'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wartość brutto'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_9)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_13)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_21)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.showChangeContractName;
    ck(v,13,0,currVal_1);
    const currVal_2:boolean = !co.showChangeContractName;
    ck(v,16,0,currVal_2);
    const currVal_3:boolean = !co.showChangeContractName;
    ck(v,22,0,currVal_3);
    const currVal_6:any = ((co.contract.perpetual === co.contractsService.PERPETUAL_NO) && co.contract.agreement_end);
    ck(v,58,0,currVal_6);
    const currVal_8:any = co.services;
    ck(v,128,0,currVal_8);
    const currVal_9:any = (co.contract.regulations.length || co.contract.files.length);
    ck(v,134,0,currVal_9);
    const currVal_10:boolean = (!co.contract.rodo_agreement && (co.contract.type != 1));
    ck(v,137,0,currVal_10);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,9,0,import0.ɵnov(v,10).transform('CONTRACTS.CONTRACT'));
    ck(v,9,0,currVal_0);
    const currVal_4:any = co.contractPaymentsStatusColors[co.contract.status];
    ck(v,47,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,48,0,import0.ɵnov(v,49).transform(('CONTRACT_STATUS.' + co.contract.status)));
    ck(v,48,0,currVal_5);
    const currVal_7:any = import0.ɵunv(v,74,0,import0.ɵnov(v,75).transform(('SETTLEMENT_TYPE.' + co.contract.settlement_type.toString())));
    ck(v,74,0,currVal_7);
  });
}
function View_ContractDetailsComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[[
        'type',
        'text'
      ]
      ],[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small btn-danger'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Usuń'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.rodoClientService.deletePosition((<any>v.parent).context.index,v.context.index)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,2,0,currVal_0);
  });
}
function View_ContractDetailsComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),20,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[[
        'type',
        'text'
      ]
      ],[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small btn-danger'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Usuń'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.rodoClientService.deleteCategory(v.context.index)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'ol',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_25)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'formControlName',
        'newPosition'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,12)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,12).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,12)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,12)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Dodaj pozycję'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.rodoClientService.addPosition(v.context.$implicit.name,co.newClientRodoForm.controls['newPosition'].value);
        const pd_0:any = ((<any>co.newClientRodoForm.controls['newPosition'].setValue('')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = v.context.$implicit.positions;
    ck(v,9,0,currVal_1);
    const currVal_9:any = 'newPosition';
    ck(v,14,0,currVal_9);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,2,0,currVal_0);
    const currVal_2:any = import0.ɵnov(v,16).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,16).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,16).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,16).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,16).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,16).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,16).ngClassPending;
    ck(v,11,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_ContractDetailsComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'row-large'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'ol',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_24)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'formControlName',
        'newCategory'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Dodaj nową grupę'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.rodoClientService.addCategory(co.newClientRodoForm.controls['newCategory'].value);
        const pd_0:any = ((<any>co.newClientRodoForm.controls['newCategory'].setValue('')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.rodoClientService.getCategories();
    ck(v,5,0,currVal_0);
    const currVal_8:any = 'newCategory';
    ck(v,10,0,currVal_8);
  },(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,12).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,12).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,12).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,12).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,12).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,12).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,12).ngClassPending;
    ck(v,7,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_ContractDetailsComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import8.DurationPipe,([] as any[])),
    import0.ɵpid(0,import5.DatePipe,[import0.LOCALE_ID]),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),67,'modal',[[
        'cancelButtonLabel',
        'Zamknij'
      ]
    ],(null as any),(null as any),(null as any),import9.View_Modal_0,import9.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'addClientRodo',
        4
      ]
      ],0,import10.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,2,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import9.View_ModalHeader_0,import9.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import10.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        Powierzenie przetwarzania danych osobowych\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,55,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import9.View_ModalContent_0,import9.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import10.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,51,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import11.ContractDetailsComponent = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,20).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,20).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.saveClientRodo(co.newClientRodoForm.controls['answer'].value,import0.ɵnov(v,9))) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },{ngSubmit: 'ngSubmit'}),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            W celu zawarcia umowy powierzenia przetwarzania danych wymagane jest uzupełnienie kategorii zakresu powierzanych danych.\n            Przykładowe kategorie i zakres powierzanych danych:\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),22,'ol',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['klienci Administratora Danych\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'ol',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['imiona, nazwiska'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['numery telefonów'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['pracownicy\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'ol',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['imiona, nazwiska'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'row-standard icon icon-download'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Pobierz wzór umowy powierzenia przetwarzania danych.'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'formControlName',
        'answer'
      ]
      ,
      [
        'type',
        'checkbox'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,55).onChange($event.target.checked)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,55).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.CheckboxControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.CheckboxControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),[' Czy przekazujesz przetwarzanie danych osobowych?\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractDetailsComponent_23)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Zatwierdź warunki przekazania przetwarzania danych osobowych'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import9.View_ModalFooter_0,import9.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import10.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import11.ContractDetailsComponent = v.component;
    const currVal_0:any = co.contractDetailsLoading;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.contractDetailsLoading;
    ck(v,6,0,currVal_1);
    const currVal_2:any = 'Zamknij';
    ck(v,9,0,currVal_2);
    const currVal_10:any = co.newClientRodoForm;
    ck(v,20,0,currVal_10);
    const currVal_19:any = 'answer';
    ck(v,57,0,currVal_19);
    const currVal_20:any = (co.newClientRodoForm.controls['answer'].value == true);
    ck(v,64,0,currVal_20);
  },(ck,v) => {
    var co:import11.ContractDetailsComponent = v.component;
    const currVal_3:any = import0.ɵnov(v,22).ngClassUntouched;
    const currVal_4:any = import0.ɵnov(v,22).ngClassTouched;
    const currVal_5:any = import0.ɵnov(v,22).ngClassPristine;
    const currVal_6:any = import0.ɵnov(v,22).ngClassDirty;
    const currVal_7:any = import0.ɵnov(v,22).ngClassValid;
    const currVal_8:any = import0.ɵnov(v,22).ngClassInvalid;
    const currVal_9:any = import0.ɵnov(v,22).ngClassPending;
    ck(v,18,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_11:any = import0.ɵinlineInterpolate(1,'',co.API_URL,'/rodo/current');
    ck(v,50,0,currVal_11);
    const currVal_12:any = import0.ɵnov(v,59).ngClassUntouched;
    const currVal_13:any = import0.ɵnov(v,59).ngClassTouched;
    const currVal_14:any = import0.ɵnov(v,59).ngClassPristine;
    const currVal_15:any = import0.ɵnov(v,59).ngClassDirty;
    const currVal_16:any = import0.ɵnov(v,59).ngClassValid;
    const currVal_17:any = import0.ɵnov(v,59).ngClassInvalid;
    const currVal_18:any = import0.ɵnov(v,59).ngClassPending;
    ck(v,54,0,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18);
    const currVal_21:boolean = !co.newClientRodoForm.controls['answer'].value;
    ck(v,68,0,currVal_21);
  });
}
function View_ContractDetailsComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-contract-details',([] as any[]),(null as any),(null as any),(null as any),View_ContractDetailsComponent_0,RenderType_ContractDetailsComponent)),
    import0.ɵdid(114688,(null as any),0,import11.ContractDetailsComponent,[
      import12.ContractsService,
      import13.BreadcrumbService,
      import14.LocalStorageService,
      import15.NotificationsService,
      import16.ActivatedRoute,
      import17.LanguageService,
      import18.MenuService,
      import16.Router,
      import19.FormService,
      import20.RodoClientService,
      import21.DateService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ContractDetailsComponentNgFactory:import0.ComponentFactory<import11.ContractDetailsComponent> = import0.ɵccf('app-contract-details',import11.ContractDetailsComponent,View_ContractDetailsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/contract/contract-details.component.ngfactory.ts